var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMp4Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34167 4C4.34167 1.79086 6.13254 0 8.34167 0H24.3417L36.3417 12V36C36.3417 38.2091 34.5508 40 32.3417 40H8.34167C6.13254 40 4.34167 38.2091 4.34167 36V4Z",
    fill: "#155EEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.3417 0L36.3417 12H28.3417C26.1325 12 24.3417 10.2091 24.3417 8V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0697 32H17.0502V27.5H17.0194L15.1869 31.9473H14.4135L12.5809 27.5H12.5502V32H11.5262V25.6587H12.8402L14.7826 30.4443H14.8177L16.7601 25.6587H18.0697V32ZM19.1903 25.6587H21.6556C22.9169 25.6587 23.7914 26.5156 23.7914 27.7812C23.7914 29.0469 22.8905 29.9038 21.6073 29.9038H20.3241V32H19.1903V25.6587ZM20.3241 26.5859V28.9897H21.3524C22.1654 28.9897 22.64 28.5503 22.64 27.7812C22.64 27.021 22.1698 26.5859 21.3568 26.5859H20.3241ZM27.5092 32V30.8003H24.3451V29.8247C24.8944 28.7876 25.6019 27.6582 26.9774 25.6587H28.5902V29.873H29.4427V30.8003H28.5902V32H27.5092ZM25.3734 29.8687V29.8994H27.5267V26.498H27.5092C26.4852 27.9834 25.8788 28.9194 25.3734 29.8687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4Svg);
export default __webpack_public_path__ + "static/media/mp4Svg.335c5feb17a9615db77a7a6e3690d706.svg";
export { ForwardRef as ReactComponent };